class Guestbook {
    constructor() {
        this.config = null;
    }

    init(config) {
        this.config = config;
    }

    entrySubmitted(response) {
        app.ajax.reload('#page');
    }

    deleteEntry(entryId) {
        app.ajax.delete('/services/user/guestbook/entry/' + entryId, {});
    }

    deleteReply(entryId) {
        app.ajax.delete('/services/user/guestbook/reply/' + entryId, {}, () => {
            app.modal.close();
        });
    }
}